import { HStack } from '@chakra-ui/react';
import { cloneElement, FC, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, rem, StyleProps, Tag, Text, usePopoverContext } from '@bonusly/design-system';

import { DropdownOption } from '../Dropdown';
import { SmartLink } from '../SmartLink/SmartLink';

interface NavMenuItemProps extends StyleProps {
	children: ReactNode;
	icon: ReactElement;
	isBeta?: boolean;
	to?: string;
	onClick?: VoidFunction;
}

export const NavMenuItem: FC<NavMenuItemProps> = ({ children, icon, isBeta, to, onClick }) => {
	const { onClose } = usePopoverContext();
	const { t } = useTranslation('common');

	return (
		<DropdownOption p={0} variant="floating" onClick={onClose} tabIndex={-1}>
			<Flex alignItems="center" as={SmartLink} data-testid="analytics-menu-item" p={3} width="100%" to={to} onClick={onClick}>
				{cloneElement(icon, { fontSize: '2xl' })}

				<HStack w="100%" justifyContent="space-between" alignItems="center">
					<Text as="span" color="gray.700" ml={2} fontSize="md" fontWeight="medium">
						{children}
					</Text>

					{isBeta && (
						<Tag variant="subtle" colorScheme="purple" size="sm" borderRadius="full" pr={rem(8)} fontWeight={'semibold'}>
							{t('beta')}
						</Tag>
					)}
				</HStack>
			</Flex>
		</DropdownOption>
	);
};
